import { Severity } from '../../types/alerts';
import { AlertTriangle, Flame, AlertCircle } from 'lucide-react';

interface SeveritySelectorProps {
  selectedSeverity: Severity | null;
  onSeverityChange: (severity: Severity | null) => void;
}

const severities: { type: Severity; icon: typeof AlertTriangle; label: string; color: string }[] = [
  { type: 'Critical', icon: Flame, label: 'Critical', color: 'text-red-500' },
  { type: 'High', icon: AlertTriangle, label: 'High', color: 'text-orange-500' },
  { type: 'Medium', icon: AlertCircle, label: 'Medium', color: 'text-yellow-500' },
];

export function SeveritySelector({ selectedSeverity, onSeverityChange }: SeveritySelectorProps) {
  const handleClick = (type: Severity) => {
    // Toggle: if already selected, unselect (null means show all)
    if (selectedSeverity === type) {
      onSeverityChange(null);
    } else {
      onSeverityChange(type);
    }
  };

  return (
    <div className="flex items-center gap-0.5 p-1 bg-card rounded-lg border border-border shadow-sm h-9">
      {severities.map((severity) => {
        const Icon = severity.icon;
        const isSelected = selectedSeverity === severity.type;
        return (
          <button
            key={severity.type}
            onClick={() => handleClick(severity.type)}
            className={`
              flex items-center justify-center gap-1.5 px-3 py-1 rounded-md text-sm font-medium transition-all min-w-[70px] h-7
              ${isSelected 
                ? 'bg-background text-foreground shadow-md ring-1 ring-primary/30' 
                : 'text-muted-foreground hover:text-foreground hover:bg-background/60'
              }
            `}
          >
            <Icon 
              className={`h-3.5 w-3.5 transition-all duration-300 ${
                isSelected ? severity.color : 'opacity-60'
              }`}
            />
            <span>{severity.label}</span>
          </button>
        );
      })}
    </div>
  );
}
